export default "__VITE_ASSET__CwUygZwp__"